// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"landing-module--wrapper--2Gd9y","textWrapper":"landing-module--textWrapper--2AlzY","blink":"landing-module--blink--2Gm0g"};